import CategoryQuery from 'Query/Category.query';
import OggGraphQuery from 'Query/OggGraph.query';
import {
    CategoryDispatcher as SourceCategoryDispatcher
} from 'SourceStore/Category/Category.dispatcher';
import { updateCurrentCategory } from 'Store/Category/Category.action';
import { updateNoMatch } from 'Store/NoMatch/NoMatch.action';
import { getCurrentUrlForOggData } from 'Util/Helper';

/** @namespace Pwa/Store/Category/Dispatcher/CategoryDispatcher */
export class CategoryDispatcher extends SourceCategoryDispatcher {
    // TODO implement logic
    onSuccess(data, dispatch, { isSearchPage }) {
        const { category = {}, category: { id }, oggraphData = {} } = data;

        if (!id && !isSearchPage) {
            dispatch(updateNoMatch(true));
        }

        dispatch(updateCurrentCategory({ ...category, oggraphData }));
    }

    prepareRequest(options) {
        const current_url = getCurrentUrlForOggData();
        const { categoryIds: id } = options;

        return [
            CategoryQuery.getQuery(options),
            OggGraphQuery.getQuery({ id, current_url, type: 'CATEGORY' })
        ];
    }
}

export default new CategoryDispatcher();
